import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { useSelectAPIEndpoint } from "../../../../utils/useSelectAPIEndpoint";
import { Line } from "react-chartjs-2";
import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    Filler,
} from "chart.js";
import { commonService } from "../../../../utils/commonService";
import { Button, Form, Col, Row } from "react-bootstrap";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { compName } from "../../../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import WidgetDetailModal from "../../WidgetDetailModal";
import AddWidgetModal from "../../AddWidgetModal";
import Comments from "../Comments/Comment";
import { setBookingPaceMonth } from "../../../../utils/slices/headerPropertySlice";
import moment from "moment";
import DatePicker from "react-datepicker";
import Loader from "../../../Loader/Loader";

const BookingPaceNew = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    Chart.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Tooltip,
        Legend,
        PointElement,
        LineElement,
        Filler
    );

    const newBookingPaceEndpoint = useSelectAPIEndpoint({
        standard: API_URL.BOOKING_PACE.NEW_BOOKING_PACE,
        datewise: API_URL.BOOKING_PACE.NEW_BOOKING_PACE_DATEWISE
    });

    const getNextWeekMonday = () => {
        const today = new Date();
        const day = today.getDay();
        const diffToMonday = (7 - day) % 7 || 7;
        const nextMonday = new Date(today);
        nextMonday.setDate(today.getDate() + diffToMonday);
        return nextMonday;
    };

    const getNextWeekSaturday = () => {
        const nextMonday = getNextWeekMonday();
        const nextSaturday = new Date(nextMonday);
        nextSaturday.setDate(nextMonday.getDate() + 6);
        return nextSaturday;
    };
    const [SelectDate, setSelectDate] = useState(getNextWeekMonday());
    const [SelectEndDate, setSelectEndDate] = useState(getNextWeekSaturday());

    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const [widgetModal, setWidgetModal] = useState(false);
    const widgetDetailRef = useRef();
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };
    const [candle_chart_loader, setcandle_chart_loader] = useState(false);

    let chartOptions = {
        indexAxis: "x",

        scales: {
            x: {
                title: {
                    display: true,
                    text: "No Of Days/Pace Days",
                },
                ticks: {
                    align: "start",
                    autoSkip: false,
                },
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: "Bookings",
                },
                grid: {
                    display: true,
                },
            },
        },

        plugins: {
            title: {
                display: true,
                text: "Booking Pace",
            },
            legend: {
                display: true,
                align: "center",
                position: "bottom",
                maxWidth: 20,
                maxHeight: 100,
                labels: {
                    boxWidth: 10,
                    boxHeight: 10,
                },
            },
            tooltip: {
                enabled: true,
                mode: "index",
                intersect: false,
                callbacks: {
                    title: function (context) {
                        return "Days/Pace Days : " + context[0].label;
                    },
                    label: function (context) {
                        let label = context.dataset.label;
                        let value = context.formattedValue;
                        let OtherData = context.dataset.otherdata[context.dataIndex];

                        return `${label} : ${value}% (${OtherData})`;
                    },
                },
            },
        },
    };
    let chartDetail = {
        labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

        datasets: [
            {
                type: "line",
                label: "RMS",
                backgroundColor: "#145f81",
                borderColor: "#145f81",
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                otherdata: [],
            },
            {
                type: "line",
                label: "LY RMS",
                backgroundColor: "#e97336",
                borderColor: "#e97336",
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                otherdata: [],
            },
            {
                type: "line",
                label: "STLY RMS",
                backgroundColor: "#196b24",
                borderColor: "#196b24",
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                otherdata: [],
            },
        ],
    };
    const [chartData, setChartData] = useState({
        chartDetail: chartDetail,
        chartOptions: chartOptions,
    });

    const getBookingPaceDetail = async () => {
        if (para?.asOfDate && SelectDate) {
            setcandle_chart_loader(true);
            let bookingPaceResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        newBookingPaceEndpoint,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        startdate: commonService.getDateInDBFormat(SelectDate),
                        enddate: commonService.getDateInDBFormat(SelectEndDate),
                    },
                },
                false
            );

            let response = apiResponse(false, bookingPaceResponse);


            if (response?.isValidate) {
                let dataFromApi = response?.data?.data;
                if (dataFromApi && dataFromApi.length > 0) {
                    let labels = [];
                    let RMS = [];
                    let LYRMS = [];
                    let STLYRMS = [];

                    let RMSValue = [];
                    let LYRMSValue = [];
                    let STLYRMSValue = [];

                    dataFromApi.map((item) => {
                        labels.push(item.leadtime);
                        RMS.push(item.currentyearper);
                        LYRMS.push(item.lastyearper);
                        STLYRMS.push(item.STLYper);

                        RMSValue.push(item.currentyear);
                        LYRMSValue.push(item.lastyear);
                        STLYRMSValue.push(item.STLY);
                    });

                    chartDetail.datasets[0].data = RMS;

                    chartDetail.datasets[1].data = LYRMS;

                    chartDetail.datasets[2].data = STLYRMS;



                    chartDetail.datasets[0].otherdata = RMSValue;

                    chartDetail.datasets[1].otherdata = LYRMSValue;

                    chartDetail.datasets[2].otherdata = STLYRMSValue;

                    chartDetail.labels = labels;
                   
                    setChartData({
                        chartDetail: chartDetail,
                        chartOptions: chartOptions,
                    });
                }
            }

            if (!response?.isValidate) {
                setChartData({ chartDetail: chartDetail, chartOptions: chartOptions });
            }

            setcandle_chart_loader(false);
        }
    };
    const handleDateChange = (dates) => {

        const [start, end] = dates;
        setSelectDate(start);
        setSelectEndDate(end);
    };
    useEffect(() => {
        if ((SelectDate, SelectEndDate)) {
            getBookingPaceDetail();
        }
    }, [SelectDate, SelectEndDate]);

    return (
        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("BookingPaceNew", "info", "")}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.BookingPaceNew,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                </div>
            )}
            <Row>
                <Col xl={12}>
                    <Row>
                        <Col xl={3}>
                            <div className="from-groups no-border-break">
                                <DatePicker id={commonService.generateGlobalClickTrackerID("BookingPaceNew", "datepicker-onchange", "")}
                                    portalId="datepicker-root"
                                    onChange={handleDateChange}
                                    startDate={
                                        SelectDate
                                            ? commonService.convertDateInTimezone(SelectDate)
                                            : ""
                                    }
                                    endDate={
                                        SelectEndDate
                                            ? commonService.convertDateInTimezone(SelectEndDate)
                                            : ""
                                    }
                                    selectsRange
                                    monthsShown={2}
                                />
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <Col xl={12}>
                    {candle_chart_loader ? (
                        <Loader />
                    ) : (
                        <>
                            {chartData && (
                                <Line
                                    data={chartData.chartDetail}
                                    options={chartData.chartOptions}
                                />
                            )}
                        </>
                    )}
                </Col>
            </Row>

            {api !== 0 && (
                <Comments widgetDetails={para} editorId={"BookingPaceNew"} />
            )}
            {showNoteSidebar && (
                <AddWidgetModal
                    showModal={showNoteSidebar}
                    closeModal={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};

export default BookingPaceNew;
